import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'kexp-footer',
  templateUrl: 'kexp-footer.component.html',
  styleUrl: 'kexp-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class KexpFooterComponent {
  protected copyrightYear = new Date().getFullYear();
  private currentUrl: string | undefined;

  constructor(private location: Location) {
    this.location.onUrlChange((url) => {
      this.currentUrl = url.split('?')[0];
    });
  }

  public currentPage(pageUrl: string): boolean {
    return this.currentUrl === pageUrl;
  }

  public createError = () => {
    throw new Error('This is a test error, did it work?');
  };
}
